// CÓDIGO 100% COMPLETO E CORRIGIDO
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import useClickOutside from '../../hooks/useClickOutside';
import { CloseIcon } from './Icons';

// --- INÍCIO DA ALTERAÇÃO: Adicionada a prop "closeOnClickOutside" ---
const Modal = ({ isOpen, onClose, title, children, footer, maxWidth = 'max-w-2xl', closeOnClickOutside = true }) => {
// --- FIM DA ALTERAÇÃO ---
    const modalRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'auto';
        };
    }, [isOpen, onClose]);

    // --- INÍCIO DA ALTERAÇÃO: O hook só é ativado se a prop for verdadeira ---
    useClickOutside(modalRef, closeOnClickOutside ? onClose : () => {});
    // --- FIM DA ALTERAÇÃO ---

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div 
            className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/80 backdrop-blur-sm animate-fade-in p-4"
            role="dialog"
            aria-modal="true"
        >
            <div
                ref={modalRef}
                className={`bg-gray-800 border border-white/10 rounded-2xl shadow-2xl w-full ${maxWidth} flex flex-col max-h-full transform transition-all duration-300 ease-out animate-scale-in`}
            >
                <header className="flex-shrink-0 flex items-center justify-between p-4 sm:p-6 border-b border-white/10">
                    <h2 className="text-xl font-bold text-white truncate">{title || ''}</h2>
                    <button onClick={onClose} title="Fechar" className="p-2 rounded-full hover:bg-white/10 transition-colors">
                        <CloseIcon size={24} />
                    </button>
                </header>

                <div className="flex-grow overflow-y-auto p-6">
                    {children}
                </div>

                {footer && (
                    <footer className="flex-shrink-0 flex justify-end gap-3 p-6 bg-black/20 rounded-b-2xl">
                        {footer}
                    </footer>
                )}
            </div>
        </div>,
        document.body
    );
};

export default Modal;